/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Communication = {
  id?: number
  name: string
  from?: string
  subject: string
  body: string
  replyTo?: string
  template?: Communication.template
  fromName?: string
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Communication {
  export enum template {
    BASE = 'base',
    CRONJOB = 'cronjob',
  }
}
